const updateObject = (oldObject, newValues) => {
    return Object.assign({}, oldObject, newValues);
};

module.exports = updateObject;
